import React from 'react';
import { DropdownTooltipText } from '@instinet-analytics/semantic-ui-components';
import chartPreview from './orderLiquidityCapsulePreview.png';

export const orderLiquidityCapsuleDescription: DropdownTooltipText = {
    body: (
        <>
            <div>
                This capsule displays your order&apos;s liquidity sourcing.
            </div>
        </>
    ),
    minPreviewHeight: 180,
    previews: [
        {
            title: 'Chart',
            src: chartPreview,
            altText: 'order-liquiditye-capsule-chart-preview',
        },
    ],
};
